import { render, staticRenderFns } from "./AcademyDetails.vue?vue&type=template&id=4877dc02&scoped=true&"
import script from "./AcademyDetails.vue?vue&type=script&lang=js&"
export * from "./AcademyDetails.vue?vue&type=script&lang=js&"
import style0 from "./AcademyDetails.vue?vue&type=style&index=0&id=4877dc02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4877dc02",
  null
  
)

export default component.exports